"use strict";
(self["webpackChunkgrowwwtoday"] = self["webpackChunkgrowwwtoday"] || []).push([["/app"],{

/***/ "./src/js/app.js":
/*!***********************!*\
  !*** ./src/js/app.js ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _toggles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./toggles */ "./src/js/toggles.js");
/* harmony import */ var _custom_add_to_cart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./custom-add-to-cart */ "./src/js/custom-add-to-cart.js");
/* harmony import */ var _sliders__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./sliders */ "./src/js/sliders.js");
/* harmony import */ var bootstrap_js_dist_tab__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! bootstrap/js/dist/tab */ "./node_modules/bootstrap/js/dist/tab.js");
/* harmony import */ var bootstrap_js_dist_tab__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(bootstrap_js_dist_tab__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! bootstrap/js/dist/modal */ "./node_modules/bootstrap/js/dist/modal.js");
/* harmony import */ var bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(bootstrap_js_dist_modal__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _fancyapps_fancybox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @fancyapps/fancybox */ "./node_modules/@fancyapps/fancybox/dist/jquery.fancybox.js");
/* harmony import */ var _fancyapps_fancybox__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_fancyapps_fancybox__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! js-cookie */ "./node_modules/js-cookie/dist/js.cookie.mjs");
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* harmony import */ var _find_my_pot__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./find-my-pot */ "./src/js/find-my-pot.js");
/* provided dependency */ var __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");










window.$ = __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
var mq = {
  xxs: 0,
  xs: 380,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600,
  xxxxl: 1800
};
var responsiveChanges = function responsiveChanges() {
  changeFooter();
};
responsiveChanges();
function changeFooter() {
  var windowWidth = $(window).width();
  if (windowWidth < mq.md) {
    $(".footer-top-menus__menu ul").hide().addClass("is-hidden");
  } else {
    $(".footer-top-menus__menu ul").show().addClass("is-show");
  }
}
function changeFilter() {
  var windowWidth = $(window).width();
  if (windowWidth < mq.lg) {
    $(".js-drawer-filter").prepend($(".js-collection-filters"));
  } else {
    (0,_functions__WEBPACK_IMPORTED_MODULE_7__.closeFilterPanel)();
    $(".js-collection-filters-aside").append($(".js-collection-filters"));
  }
}
changeFilter();

// Debounce function to limit how often a function is executed
function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
// Below 1200px the search field moves under the header row (frame E1), into
// the .js-header-end container that holds its 16px side margins. The menus stay
// in the header markup; the mobile menu is its own drill-down panel
// (snippets/base-panel.liquid, assets/site-header.js).
function replaceMenu() {
  if ($(window).width() < mq.xl) {
    $(".js-header-end > .container").prepend($(".js-header-search"));
  } else {
    $(".js-header-main").append($(".js-header-search"));
  }
  $(".js-header-main-actions").append($(".js-wish-list")).append($(".js-lang-switch"));
}
var homeLayoutMode = null;
var replaceHome = function replaceHome() {
  var nextLayoutMode = $(window).width() < mq.md ? 'mobile' : 'desktop';
  if (homeLayoutMode === nextLayoutMode) return;
  homeLayoutMode = nextLayoutMode;
  (0,_sliders__WEBPACK_IMPORTED_MODULE_2__.destroyHomeHeroAsideMobileSlider)();
  if (nextLayoutMode === 'mobile') {
    $(".js-home-hero-top").append($(".js-home-hero-usp"));
    $(".js-home-hero-middle").append($(".js-home-hero-category"));
    $(".js-home-hero-end").append($(".js-home-hero-main"));
    if ($(".js-home-hero-aside-mobile .js-home-hero-aside-element").length === 0) {
      $(".js-home-hero-aside-mobile").append($(".js-home-hero-aside-element"));
    }
    if ($(".js-home-hero-aside-mobile .js-category-aside-block").length === 0) {
      $(".js-home-hero-aside-mobile").append($(".js-category-aside-block"));
    }
  } else {
    $(".js-home-hero-top").append($(".js-home-hero-main"));
    $(".js-home-hero-middle").append($(".js-home-hero-usp"));
    $(".js-home-hero-end").append($(".js-home-hero-category"));
    if ($(".js-home-hero-aside-desktop .js-home-hero-aside-element").length === 0) {
      $(".js-home-hero-aside-desktop").append($(".js-home-hero-aside-element"));
    }
    if ($(".js-category-aside .js-category-aside-block").length === 0) {
      $(".js-category-aside").append($(".js-category-aside-block"));
    }
  }
  window.requestAnimationFrame(function () {
    (0,_sliders__WEBPACK_IMPORTED_MODULE_2__.initHomeHeroAsideMobileSlider)();
  });
};
var replaceHomeList = function replaceHomeList() {
  if ($(window).width() < mq.lg) {
    $(".js-plants-tab-first").append($(".js-plants-content-first"));
    $(".js-plants-tab-second").append($(".js-plants-content-second"));
  } else {
    $(".js-plants-row").prepend($(".js-plants-content-second"));
    $(".js-plants-row").prepend($(".js-plants-content-first"));
  }
};
function checkSiteNotice() {
  // Only hide if user previously dismissed via cookie
  if (js_cookie__WEBPACK_IMPORTED_MODULE_6__["default"].get("notice-hidden") === "true") {
    $(".js-site-notice").addClass("d-none");
    $(".js-home-hero").addClass("no-sitenotice");
    $(".js-site-notice-cols").addClass("d-none");
  }
}

// On click js-close-notice use js-cookie to set "notice-hidden" cookie to true and hide the notice
$(document).on("click", ".js-close-notice", function () {
  // Set cookie and hide notice
  js_cookie__WEBPACK_IMPORTED_MODULE_6__["default"].set("notice-hidden", "true", {
    expires: 1
  });
  $(".js-site-notice").addClass("d-none");
  $(".js-home-hero").addClass("no-sitenotice");
  $(".js-site-notice-cols").addClass("d-none");
});
$(document).on("click", ".js-quickview-toggle", function (event) {
  (0,_find_my_pot__WEBPACK_IMPORTED_MODULE_8__.showQuickView)(event);
});
$(document).on("click", ".js-potting-checkbox", function (event) {
  $(".js-potting-option").toggleClass("show-border");
});
var screenWidth = $(window).width();
$(window).on("resize", function () {
  if (screenWidth === $(window).width()) {
    return;
  }
  screenWidth = $(window).width();
  responsiveChanges();
  replaceMenu();
  changeFilter();
  replaceHome();
  replaceHomeList();
});
checkSiteNotice();
replaceHomeList();
replaceHome();
replaceMenu();

// checkRedirect();

/***/ }),

/***/ "./src/js/custom-add-to-cart.js":
/*!**************************************!*\
  !*** ./src/js/custom-add-to-cart.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   updateCart: () => (/* binding */ updateCart)
/* harmony export */ });
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* harmony import */ var _sliders__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./sliders */ "./src/js/sliders.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }


// De bestaande actie-eigenaar deelt alleen de visuele pending-toestand.
const pendingButtons = new WeakMap();
function setButtonPending(button, pending) {
  if (!button) return false;
  if (pending) {
    if (pendingButtons.has(button)) return false;
    const snapshot = {
      disabled: button.disabled,
      busy: button.getAttribute('aria-busy'),
      ariaDisabled: button.getAttribute('aria-disabled'),
      tabindex: button.getAttribute('tabindex'),
      width: button.style.width,
      height: button.style.height,
      loading: button.classList.contains('is-loading')
    };
    pendingButtons.set(button, snapshot);
    const bounds = button.getBoundingClientRect();
    const style = window.getComputedStyle(button);
    const horizontal = style.boxSizing === 'border-box' ? 0 : parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);
    const vertical = style.boxSizing === 'border-box' ? 0 : parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
    button.style.width = Math.max(0, bounds.width - horizontal) + 'px';
    button.style.height = Math.max(0, bounds.height - vertical) + 'px';
    button.classList.add('is-loading');
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');
    if (button.tagName === 'A') button.setAttribute('tabindex', '-1');
    return true;
  }
  const snapshot = pendingButtons.get(button);
  if (!snapshot) return false;
  button.disabled = snapshot.disabled;
  button.style.width = snapshot.width;
  button.style.height = snapshot.height;
  button.classList.toggle('is-loading', snapshot.loading);
  [['aria-busy', snapshot.busy], ['aria-disabled', snapshot.ariaDisabled], ['tabindex', snapshot.tabindex]].forEach(function (entry) {
    if (entry[1] === null) button.removeAttribute(entry[0]);
    else button.setAttribute(entry[0], entry[1]);
  });
  pendingButtons.delete(button);
  return true;
}
window.FlorafyUI = window.FlorafyUI || {};
window.FlorafyUI.setButtonPending = setButtonPending;

// The legacy login link targets the shared recovery dialog through Bootstrap attributes.
// Capture at window before Bootstrap's delegated document listener to keep one dialog owner.
window.addEventListener('click', function (event) {
  const opener = event.target.closest('[data-bs-toggle="modal"][data-bs-target="#forgotPassword"]');
  if (!opener) return;
  const dialog = document.getElementById('forgotPassword');
  if (!dialog || !dialog.matches('dialog.ui-dialog')) return;
  event.preventDefault();
  event.stopPropagation();
  if (!dialog.open) {
    opener.focus({ preventScroll: true });
    dialog.showModal();
    (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();
  }
}, true);

// Native dialog behoudt focus, Escape en focusherstel; formulieren blijven bij hun eigenaar.
document.addEventListener('click', function (event) {
  const disabled = event.target.closest('.ui-button[aria-disabled="true"]');
  if (disabled) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }
  const opener = event.target.closest('[data-ui-dialog-open]');
  if (opener) {
    const dialog = document.getElementById(opener.getAttribute('data-ui-dialog-open'));
    if (dialog && dialog.matches('dialog.ui-dialog') && !dialog.open) {
      if (dialog.id === 'forgotPassword') event.preventDefault();
      dialog.showModal();
      if (dialog.id === 'forgotPassword') (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();
    }
  }
  const closer = event.target.closest('[data-ui-dialog-close]');
  if (closer) {
    const dialog = closer.closest('dialog.ui-dialog');
    if (dialog) dialog.close();
  }
}, true);

const cartButtonStates = new WeakMap();
function setButtonState(button, state, originalText) {
  if (!button) return;
  let snapshot = cartButtonStates.get(button);
  if (state === 'loading' && !snapshot) {
    const labels = Array.from(button.querySelectorAll('.ui-button__label, span')).filter(function (node) {
      return !node.closest('.btn-icon__icon, .ui-button__count') && !node.querySelector('span, svg, i');
    });
    snapshot = {
      labels: labels.map(function (node) { return [node, node.textContent]; }),
      icons: Array.from(button.querySelectorAll('.btn-icon__icon i')).map(function (node) { return [node, node.className]; }),
      invalid: button.getAttribute('aria-invalid')
    };
    cartButtonStates.set(button, snapshot);
  }
  if (!snapshot) return;
  let status = button.parentNode && button.parentNode.querySelector('.js-atc-status');
  if (!status && button.parentNode) {
    status = document.createElement('span');
    status.className = 'js-atc-status visually-hidden';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    button.parentNode.insertBefore(status, button.nextSibling);
  }
  button.classList.remove('is-success', 'is-error');
  if (state === 'loading') {
    setButtonPending(button, true);
    button.removeAttribute('aria-invalid');
    if (status) status.textContent = window.translations?.button?.adding || 'Toevoegen...';
    if (snapshot.icons[0]) snapshot.icons[0][0].className = 'fa-solid fa-spinner';
  } else if (state === 'success') {
    button.classList.remove('is-loading');
    button.classList.add('is-success');
    button.setAttribute('aria-busy', 'false');
    snapshot.labels.forEach(function (entry) { entry[0].textContent = window.translations?.button?.added || 'Toegevoegd!'; });
    if (status) status.textContent = window.translations?.button?.added || 'Toegevoegd!';
    if (snapshot.icons.length) snapshot.icons[snapshot.icons.length - 1][0].className = 'fa-solid fa-check';
  } else if (state === 'error' || state === 'default') {
    setButtonPending(button, false);
    snapshot.labels.forEach(function (entry) { entry[0].textContent = originalText === undefined ? entry[1] : originalText; });
    snapshot.icons.forEach(function (entry) { entry[0].className = entry[1]; });
    if (snapshot.invalid === null) button.removeAttribute('aria-invalid');
    else button.setAttribute('aria-invalid', snapshot.invalid);
    if (state === 'error') {
      button.classList.add('is-error');
      if (snapshot.icons.length) snapshot.icons[snapshot.icons.length - 1][0].className = 'fa-solid fa-triangle-exclamation text-danger';
    }
    if (status) status.textContent = '';
    if (state === 'default') cartButtonStates.delete(button);
  }
}

function clearCartMutationError(container) {
  if (!container) return;
  var error = container.querySelector('.js-cart-mutation-error');
  if (error) error.remove();
}

function showCartMutationError(form, button, message) {
  clearCartMutationError(form);
  var error = document.createElement('div');
  error.className = 'ui-notice ui-notice--error js-cart-mutation-error mt-1';
  error.setAttribute('role', 'alert');
  var errorBody = document.createElement('span');
  errorBody.className = 'ui-notice__body';
  errorBody.textContent = message;
  error.appendChild(errorBody);
  if (button && button.parentNode) {
    var controls = button.closest('.product-quantity') || button;
    controls.parentNode.insertBefore(error, controls.nextSibling);
  } else {
    form.appendChild(error);
  }
}

function rejectCartMutation(response) {
  if (response.ok) return Promise.resolve(response);
  return response.json().catch(function () {
    return {};
  }).then(function (body) {
    var fallback = window.translations && window.translations.button && window.translations.button.error || 'Er is iets misgegaan. Probeer het opnieuw.';
    throw new Error(body && body.description || fallback);
  });
}

function clearCartAddedNotice(container) {
  var notice = container && container.querySelector('.js-cart-added-notice');
  if (notice) notice.remove();
}
function showCartAddedNotice(section, button, syncFailed) {
  if (!section) return;
  clearCartAddedNotice(section);
  var notice = document.createElement('div');
  notice.className = 'ui-notice ui-notice--info js-cart-added-notice mt-1';
  notice.setAttribute('role', 'status');
  var body = document.createElement('span');
  body.className = 'ui-notice__body';
  body.textContent = (syncFailed
    ? window.translations?.cart?.addedDetailsError || 'Toegevoegd, maar de winkelwagengegevens konden niet worden bijgewerkt. Controleer je winkelwagen.'
    : window.translations?.cart?.addedRefreshError || 'Toegevoegd, maar de winkelwagen kon niet worden getoond. Bekijk je winkelwagen.') + ' ';
  var link = document.createElement('a');
  link.href = window.Shopify.routes.root + 'cart';
  link.textContent = window.translations?.cart?.showCart || 'Toon winkelwagen';
  body.appendChild(link);
  notice.appendChild(body);
  if (button && button.parentNode) {
    var controls = button.closest('.product-quantity') || button;
    controls.parentNode.insertBefore(notice, controls.nextSibling);
  } else section.appendChild(notice);
}
function initAddToCartForms() {
  var addToCartForms = document.querySelectorAll('form[action="/cart/add"]');
  addToCartForms.forEach(function (form) {
    if (form.dataset.atcBound) return; // idempotency guard
    form.dataset.atcBound = '1';
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = form.querySelector('.js-add-to-cart');
      if (button && (button.disabled || pendingButtons.has(button))) return;
      clearCartMutationError(form);
      clearCartAddedNotice(form);
      var addCommitted = false;
      setButtonState(button, 'loading');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: "POST",
        body: new FormData(form)
      }).then(rejectCartMutation).then(function () {
        addCommitted = true;
        return fetch(window.Shopify.routes.root + 'cart.js');
      }).then(rejectCartMutation).then(function (response) {
        return response.json();
      }).then(function (cart) {
        clearCartMutationError(form);
        setButtonState(button, 'success');
        var firstCartCount = document.querySelector('.js-cart-count');
        if (firstCartCount) firstCartCount.classList.add('header-main__cart--hasitems');
        document.querySelectorAll('.js-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return updateCart(cart);
      }).then(function () {
        (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openMiniCart)();
        (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.debounceReInitSliders)();
        setTimeout(function () {
          setButtonState(button, 'default');
        }, 1500);
      }).catch(function (error) {
        if (addCommitted || error.cartMutationCommitted) {
          setButtonState(button, 'success');
          showCartAddedNotice(form, button, error.preorderSyncFailed);
          setTimeout(function () {
            setButtonState(button, 'default');
          }, 1500);
          return;
        }
        setButtonState(button, 'error');
        showCartMutationError(form, button, error.message);
      });
    });
  });
}
initAddToCartForms();
window.addEventListener('combined-listing:swapped', initAddToCartForms);

/**
 * Handle related products add to cart
 */
function initRelatedAddToCart() {
  var addToCartItems = document.querySelectorAll('form.js-related-add-to-cart');
  addToCartItems.forEach(function (form) {
    if (form.dataset.relatedAtcBound) return;
    form.dataset.relatedAtcBound = '1';
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var button = form.querySelector('.js-add-to-cart');
      if (button && (button.disabled || pendingButtons.has(button))) return;
      clearCartMutationError(form);
      clearCartAddedNotice(form);
      var addCommitted = false;
      setButtonState(button, 'loading');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: "POST",
        body: new FormData(form)
      }).then(rejectCartMutation).then(function () {
        addCommitted = true;
        return fetch(window.Shopify.routes.root + 'cart.js');
      }).then(rejectCartMutation).then(function (response) {
        return response.json();
      }).then(function (cart) {
        clearCartMutationError(form);
        setButtonState(button, 'success');
        var firstCartCount = document.querySelector('.js-cart-count');
        if (firstCartCount) firstCartCount.classList.add('header-main__cart--hasitems');
        document.querySelectorAll('.js-cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        return updateCart(cart);
      }).then(function () {
        setTimeout(function () {
          setButtonState(button, 'default');
        }, 1500);
      }).catch(function (error) {
        if (addCommitted || error.cartMutationCommitted) {
          setButtonState(button, 'success');
          showCartAddedNotice(form, button, error.preorderSyncFailed);
          setTimeout(function () {
            setButtonState(button, 'default');
          }, 1500);
          return;
        }
        setButtonState(button, 'error');
        showCartMutationError(form, button, error.message);
      });
    });
  });
}
function updateCart(_x3) {
  var place = window.captureMinicartPlace ? window.captureMinicartPlace() : null;
  if (window.setMinicartLoading) window.setMinicartLoading(true);
  return _updateCart.call(this, _x3, place).finally(function () {
    if (window.setMinicartLoading) window.setMinicartLoading(false);
  });
}
function _updateCart() {
  _updateCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(cart, place) {
    var minicartSectionUrl, res, text, html, newBox, jsCart, cartPageSectionUrl, _res, _text, _html, _newBox;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return new Promise(function (resolve) {
            window.dispatchEvent(new CustomEvent('cart:updated', {
              detail: {
                action: 'add',
                cart: cart,
                done: resolve // listeners roepen dit aan als ze klaar zijn
              }
            }));
          });
        case 2:
          minicartSectionUrl = cartSectionUrl('base-minicart');
          _context5.next = 6;
          return fetch(minicartSectionUrl);
        case 6:
          res = _context5.sent;
          _context5.next = 9;
          return res.text();
        case 9:
          text = _context5.sent;
          html = document.createElement('div');
          html.innerHTML = text;
          newBox = html.querySelector(".drawer-cart");
          if (window.replaceMinicartContent) {
            window.replaceMinicartContent(newBox, place);
          } else {
            document.querySelector('.drawer-cart').innerHTML = newBox.innerHTML;
            if (window.updateMinicartShippingLabel) window.updateMinicartShippingLabel();
          }

          // Check if there's a .js-cart on the page
          jsCart = document.querySelector('.js-cart');
          if (!jsCart) {
            _context5.next = 27;
            break;
          }
          cartPageSectionUrl = cartSectionUrl('page-cart');
          _context5.next = 19;
          return fetch(cartPageSectionUrl);
        case 19:
          _res = _context5.sent;
          _context5.next = 22;
          return _res.text();
        case 22:
          _text = _context5.sent;
          _html = document.createElement('div');
          _html.innerHTML = _text;
          _newBox = _html.querySelector(".js-cart");
          document.querySelector('.js-cart').innerHTML = _newBox.innerHTML;
          if (window.initializeCartPageControls) window.initializeCartPageControls();
        case 27:
          initRelatedAddToCart();
          (0,_sliders__WEBPACK_IMPORTED_MODULE_1__.debounceReInitSliders)();
        case 30:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return _updateCart.apply(this, arguments);
}

// Init related add to cart
initRelatedAddToCart();

// Expose cart refresh globally so external scripts (e.g. Doofinder) can trigger a full minicart update.
// Debounced so rapid successive calls (e.g. theme ATC + interceptor firing together) only run once.
(function() {
  var _refreshTimer = null;
  window.florafyUpdateCart = function() {
    clearTimeout(_refreshTimer);
    _refreshTimer = setTimeout(function() {
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) { return updateCart(cart); });
    }, 300);
  };
})();

// js-cart-item-delete-toggle
$(document).on("click", ".js-cart-item-delete-toggle", function (e) {
  $(this).closest('.cart-item').find('.cart-item-delete').addClass('is-active');
});
$(document).on("click", ".js-cart-item-delete__close", function (e) {
  $(this).closest('.cart-item-delete').removeClass('is-active');
});


/***/ }),

/***/ "./src/js/find-my-pot.js":
/*!*******************************!*\
  !*** ./src/js/find-my-pot.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PotFinder: () => (/* binding */ PotFinder),
/* harmony export */   showQuickView: () => (/* binding */ showQuickView)
/* harmony export */ });
/* harmony import */ var _custom_add_to_cart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./custom-add-to-cart */ "./src/js/custom-add-to-cart.js");
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* provided dependency */ var __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _require = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"),
  fn = _require.fn,
  type = _require.type;


window.$ = __webpack_provided_window_dot_jQuery = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
function clearPotFinderError(section) {
  var notice = section && section.querySelector('.js-potfinder-error, .js-potfinder-cart-link');
  if (notice) notice.remove();
}
function showPotFinderError(section, button, failure) {
  if (!section) return;
  clearPotFinderError(section);
  var fallback = window.translations?.cart?.mutationError || 'Er is iets misgegaan. Probeer het opnieuw.';
  var body = failure && failure.responseJSON;
  if (!body && failure && failure.responseText) {
    try { body = JSON.parse(failure.responseText); }
    catch (parseError) { body = null; }
  }
  var message = body && (body.description || body.message);
  var notice = document.createElement('div');
  notice.className = 'ui-notice ui-notice--error js-potfinder-error mt-1';
  notice.setAttribute('role', 'alert');
  var text = document.createElement('span');
  text.className = 'ui-notice__body';
  text.textContent = typeof message === 'string' && message.trim() ? message : fallback;
  notice.appendChild(text);
  if (button && button.parentNode) button.parentNode.insertBefore(notice, button.nextSibling);
  else section.appendChild(notice);
}
function showPotFinderCartLink(section, button, syncFailed) {
  if (!section) return;
  clearPotFinderError(section);
  var notice = document.createElement('div');
  notice.className = 'ui-notice ui-notice--info js-potfinder-cart-link mt-1';
  notice.setAttribute('role', 'status');
  var body = document.createElement('span');
  body.className = 'ui-notice__body';
  body.textContent = (syncFailed
    ? window.translations?.cart?.addedDetailsError || 'Toegevoegd, maar de winkelwagengegevens konden niet worden bijgewerkt. Controleer je winkelwagen.'
    : window.translations?.cart?.addedRefreshError || 'Toegevoegd, maar de winkelwagen kon niet worden getoond. Bekijk je winkelwagen.') + ' ';
  var link = document.createElement('a');
  link.href = window.Shopify.routes.root + 'cart';
  link.textContent = window.translations?.cart?.showCart || 'Toon winkelwagen';
  body.appendChild(link);
  notice.appendChild(body);
  if (button && button.parentNode) button.parentNode.insertBefore(notice, button.nextSibling);
  else section.appendChild(notice);
}
var PotFinder = /*#__PURE__*/function () {
  function PotFinder() {
    _classCallCheck(this, PotFinder);
    // Define the selectors
    this.plantData = ".js-plant-configuration";
    this.potSelector = ".js-select-pot";
    this.pottingOptionsSelector = ".js-potting-option";
    this.pottingOptionsCheckboxes = ".js-potting-checkbox";
    this.fillingMaterialSelector = ".js-filling-material";
    this.fillingVariantSelector = ".js-filling-variant";
    this.fillingQuantitySelector = ".js-filling-quantity";

    // Hold the selected pot and potting
    this.selectedPot = null;
    this.selectedPotting = null;

    // Define an add-to-cart array
    this.addToCartObject = [];

    // Quantity selectors
    this.quantityInputSelector = ".cart-item-quantity__input";
    this.minusButtonSelector = ".cart-item-quantity__btns.is-min";
    this.plusButtonSelector = ".cart-item-quantity__btns.is-plus";

    // Add to cart btn
    this.addToCartButton = ".js-add-to-cart";

    // Define diameter options
    this.pottingDiameters = [];

    // Initialize the find-my-pot logic
    this.init();
  }

  /**
   * Init function to setup the find-my-pot logic
   */
  return _createClass(PotFinder, [{
    key: "init",
    value: function init() {
      this.getPottingDiameters(); // Get the potting diameters
      this.addEventListeners(); // Add event listeners
    }

    /**
     * Get the potting diameters
     *
     * @returns void
     */
  }, {
    key: "getPottingDiameters",
    value: function getPottingDiameters() {
      var _this = this;
      var pottingOptions = $(this.pottingOptionsSelector); // Gebruik jQuery om elementen te selecteren
      this.pottingDiameters = [];
      pottingOptions.each(function (index, option) {
        _this.pottingDiameters.push($(option).data("diameter")); // Gebruik jQuery om toegang te krijgen tot data attributen
      });
    }

    /**
     * Add event listeners to the necessary elements
     */
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;
      // Gedelegeerd: potten die de loader later toevoegt zijn ook klikbaar
      $(document).off("click.potfinder", this.potSelector).on("click.potfinder", this.potSelector, this.handlePotChange.bind(this));
      $(this.pottingOptionsCheckboxes).on("change", this.updateTotalConfigurationPrice.bind(this));

      // Quantity selectors
      $(this.minusButtonSelector).on("click", this.updateQuantity.bind(this, -1));
      $(this.plusButtonSelector).on("click", this.updateQuantity.bind(this, 1));

      // Manual quantity input
      $(this.quantityInputSelector).on("input", function (fn) {
        // Make sure the input is a number and at least 1
        var quantity = parseInt($(_this2.quantityInputSelector).val(), 10);
        if (isNaN(quantity) || quantity < 1) quantity = 1;
        $(_this2.quantityInputSelector).val(quantity);
        _this2.updateTotalConfigurationPrice();
      });

      // Pot quantity input - ensure cart object is updated when pot quantity changes
      $('.js-pot-quantity-input').on("input change", function () {
        _this2.updateTotalConfigurationPrice();
      });
      // Also listen for pot quantity +/- button clicks
      $('.js-pot-qty-minus, .js-pot-qty-plus').on("click", function () {
        setTimeout(function() {
          _this2.updateTotalConfigurationPrice();
        }, 10);
      });

      $(document).on("change", "".concat(this.fillingMaterialSelector, ", ").concat(this.fillingVariantSelector), this.updateTotalConfigurationPrice.bind(this));
      $(document).on("input change", this.fillingQuantitySelector, this.updateTotalConfigurationPrice.bind(this));
      $(document).on("click", ".js-filling-qty-minus, .js-filling-qty-plus", function () {
        setTimeout(function() {
          _this2.updateTotalConfigurationPrice();
        }, 10);
      });

      // Add to cart button
      $(this.addToCartButton).on("click", this.addToCart.bind(this));
    }

    /**
     * Handle the pot change event, we need to do several things here:
     * 1. Check if the current "radio" pot input is selected, if so deselect it, else select it... Since radio inputs are not deselected by default
     * 2. Get the selected pot diameter and check if that minimum diameter is available in the potting options
     * 3. Handle the potting options
     * 4. Update the total configuration price
     * 5. Create the add to cart object
     *
     * @param {Event} event
     */
  }, {
    key: "handlePotChange",
    value: function handlePotChange(event) {
      event.preventDefault(); // Prevent the default event
      var selectedPot = $(event.currentTarget).parent().find("input"); // Get selected jQuery object

      // Step 1: Handle the checked state of the radio input
      if (selectedPot.is(":checked")) selectedPot.prop("checked", false);else selectedPot.prop("checked", true);

      // Fill the data of the quickview info:
      var quickViewData = $(event.currentTarget).parent().find(".js-quickview-toggle");
      $(".js-quickview__title").html(quickViewData.data("title"));
      $(".js-quickview__description").html(quickViewData.data("description"));
      $(".js-quickview__image").attr("src", quickViewData.data("image"));
      $(".js-quickview__link").attr("href", quickViewData.data("url"));

      // Show when needed
      if (selectedPot.is(":checked")) $(".js-quick-view-detail").removeClass("d-none");else $(".js-quick-view-detail").addClass("d-none");
      var price = quickViewData.data("price");
      var priceString = price.toString();
      var modifiedPrice = priceString.slice(0, -2) + "<span>" + priceString.slice(-2) + "</span>";
      $(".js-quickview__price").html(modifiedPrice);

      // Save globally
      this.selectedPot = selectedPot.is(":checked") ? selectedPot : null;

      // Step 2: Get the selected pot diameter
      var selectedPotDiameter = this.getOppotDiameter(selectedPot.is(":checked") ? selectedPot.data("diameter") : null);

      // Step 3: Handle the potting options
      this.handlePottingOptions(selectedPotDiameter);

      // Step 4: Update the total configuration price
      this.updateTotalConfigurationPrice();
    }

    /**
     * Get oppot diameter
     *
     * @param {number} diameter
     *
     * @returns {number|null}
     */
  }, {
    key: "getOppotDiameter",
    value: function getOppotDiameter(diameter) {
      // Start off with nothing
      var fittingDiameter = null;

      // Loop over the potting diameters to find the first one that fits
      this.pottingDiameters.forEach(function (pottingDiameter) {
        // As long as it's bigger we need the more expensive potting option
        if (diameter >= pottingDiameter) {
          fittingDiameter = pottingDiameter;
          return;
        }
      });
      return fittingDiameter;
    }

    /**
     * Handle the potting options
     *
     * @param {number|null} diameter
     */
  }, {
    key: "handlePottingOptions",
    value: function handlePottingOptions(oppotDiameter) {
      // If there's no diameter, we need to hide all the options and uncheck all the checkboxes
      if (oppotDiameter === null) {
        $(this.pottingOptionsSelector).removeClass("is-active");
        $(this.pottingOptionsCheckboxes).prop("checked", false);
        this.selectedPotting = null;
        return;
      }

      // Get the potting option that matches the diameter
      var matchingPottingOption = $("".concat(this.pottingOptionsSelector, "[data-diameter=\"").concat(oppotDiameter, "\"]"));

      // Save the potting option globally
      this.selectedPotting = matchingPottingOption;

      // If this option already has the class 'active' don't do anything
      if (matchingPottingOption.hasClass("is-active")) return;

      // if there's a $(this.pottingOptionsCheckboxes) where checked is true, uncheck all and recheck the matching one
      if ($(this.pottingOptionsCheckboxes).is(":checked")) {
        $(this.pottingOptionsCheckboxes).prop("checked", false);
        matchingPottingOption.find(this.pottingOptionsCheckboxes).prop("checked", true);
      }

      // Remove the checked state from all the checkboxes
      $(this.pottingOptionsSelector).removeClass("is-active");
      matchingPottingOption.addClass("is-active");
    }

    /**
     * Update the total configuration price
     */
  }, {
    key: "updateTotalConfigurationPrice",
    value: function updateTotalConfigurationPrice() {
      var _plantData$data, _$$val;
      // Reset the add to cart object
      this.addToCartObject = [];

      // Get the quantity from the product input
      var quantity = parseInt($('input[name="quantity"]').val());

      // Get the plant and it's initial price
      var plantData = $(this.plantData);
      var plantPrice = (_plantData$data = plantData.data("price")) !== null && _plantData$data !== void 0 ? _plantData$data : 0;
      var plantProductId = plantData.data("product-id");
      var plantProductVariantId = (_$$val = $('#variant-id').val()) !== null && _$$val !== void 0 ? _$$val : null;
      if (plantData.length > 0) {
        // Add the pot to the cart
        this.addToCartObject.push({
          id: plantProductId,
          variation: plantProductVariantId,
          quantity: quantity,
          type: 'plant'
        });
      }

      // Get the pot data - use selectedPot if set, otherwise find checked pot directly
      var potData = this.selectedPot ? $(this.selectedPot) : $('input[name="addExtraPot"]:checked');
      var potPrice = potData.length > 0 ? potData.data("pot-price") : null;
      var potVariationId = potData.length > 0 ? parseInt(potData.val()) : null;
      var potProductId = potData.length > 0 ? potData.data("product-id") : null;

      // if there's a pot, add it to the cart
      if (potData.length > 0 && potVariationId) {
        // Get pot quantity from independent selector (defaults to plant quantity)
        var potQuantityInput = document.querySelector('.js-pot-quantity-input');
        var potQuantity = potQuantityInput ? parseInt(potQuantityInput.value) || quantity : quantity;
        console.log('🌱 PotFinder - Adding pot to cart:', {
          potProductId: potProductId,
          potVariationId: potVariationId,
          potQuantityInputFound: !!potQuantityInput,
          potQuantityInputValue: potQuantityInput ? potQuantityInput.value : 'N/A',
          parsedPotQuantity: potQuantity,
          fallbackQuantity: quantity
        });
        this.addToCartObject.push({
          id: potProductId,
          variation: potVariationId,
          quantity: potQuantity,
          type: 'pot'
        });
      }
      if (this.selectedPotting === null) {
        // Fallback: if no match is found, use .singular_potting_option
        this.selectedPotting = $('.singular_potting_option');
      }

      // Get the potting data
      var pottingData = $(this.selectedPotting).find(".js-potting-checkbox:checked");
      var pottingPrice = pottingData.length > 0 ? pottingData.data("potting-price") : null;
      var pottingVariationId = pottingData.length > 0 ? parseInt(pottingData.val()) : null;
      var pottingProductId = pottingData.length > 0 ? pottingData.data("product-id") : null;

      // if there's a potting option, add it to the cart
      if (pottingData.length > 0) {
        this.addToCartObject.push({
          id: pottingProductId,
          variation: pottingVariationId,
          quantity: quantity,
          type: 'potting'
        });
      }

      var fillingMaterial = $('input[name="addFillingMaterial"]:checked');
      var fillingVariant = fillingMaterial.length > 0 && fillingMaterial.val() ? $('input[name="addFillingVariant"]:checked[data-material-id="' + fillingMaterial.val() + '"]') : $();
      var fillingPrice = fillingVariant.length > 0 ? fillingVariant.data("addon-price") : null;
      var fillingVariationId = fillingVariant.length > 0 ? parseInt(fillingVariant.val()) : null;
      var fillingProductId = fillingVariant.length > 0 ? fillingVariant.data("product-id") : null;
      var fillingQuantityInput = fillingVariant.length > 0 ? fillingVariant.closest('.js-filling-detail').find(this.fillingQuantitySelector)[0] : null;
      var fillingQuantity = fillingQuantityInput ? parseInt(fillingQuantityInput.value) || 1 : 1;

      if (fillingVariant.length > 0 && fillingVariationId) {
        this.addToCartObject.push({
          id: fillingProductId,
          variation: fillingVariationId,
          quantity: fillingQuantity,
          type: 'opvul'
        });
      }

      // Get the total price
      var totalPrice = 0;
      // Get pot quantity for price calculation
      var potQtyForPrice = potData.length > 0 ? (document.querySelector('.js-pot-quantity-input') ? parseInt(document.querySelector('.js-pot-quantity-input').value) || quantity : quantity) : 0;
      if (plantPrice > 0) totalPrice += plantPrice * quantity;
      if (potPrice > 0) totalPrice += potPrice * potQtyForPrice;
      if (pottingPrice > 0) totalPrice += pottingPrice * quantity;
      if (fillingPrice > 0) totalPrice += fillingPrice * fillingQuantity;

      // Fill in the price
      if (potData.length > 0 || pottingData.length > 0 || fillingVariant.length > 0) $(".js-configuration-price").removeClass("d-none");else $(".js-configuration-price").addClass("d-none");
      $(".js-total-cents").text(totalPrice.toString().slice(-2));
      $(".js-total-euros").text(totalPrice.toString().slice(0, -2));
    }

    /**
     * Add to cart functionality
     */
  }, {
    key: "addToCart",
    value: (function () {
      var _addToCart = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var isPreorder, productData, requestBody, res, cart, mutationSucceeded = false, preorderSyncPending = false;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // Always rebuild the cart object to get fresh quantities
              this.addToCartObject = [];
              this.updateTotalConfigurationPrice();
              isPreorder = $('.js-plant-configuration[data-preorder="true"]').length > 0;
              var plantConfigEl = document.querySelector('.js-plant-configuration[data-preorder="true"]') || document.querySelector('.js-plant-configuration');
              var deliveryMatchProperties = window.deliveryMatchPropertiesFromElement ? window.deliveryMatchPropertiesFromElement(plantConfigEl) : isPreorder ? {
                '_pre-order': 'true'
              } : {};
              // Generate a unique configuration ID for all items in this configuration
              // Using timestamp + random string to prevent collisions when adding multiple configs quickly
              var configurationId = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
              productData = this.addToCartObject.map(function (product) {
                var _product$variation;
                var properties;

                // Greeting card is ORDER-level, not configuration-level - don't link it to configuration
                if (product.type === 'greeting_card') {
                  properties = {
                    '_kaartje_bericht': product.message,
                    '_greeting_card': 'true',
                    '_type': product.type
                  };
                  properties[window.translations && window.translations.greetingCard && window.translations.greetingCard.messageLabel || 'Card message'] = product.message;
                } else {
                  // Regular configuration items (plant, pot, potting, filling)
                  properties = {
                    _sub: "true",
                    _configuration_id: configurationId,
                    _type: product.type
                  };
                  if (product.type === 'plant') {
                    Object.assign(properties, deliveryMatchProperties);
                  }
                }

                return {
                  id: (_product$variation = product.variation) !== null && _product$variation !== void 0 ? _product$variation : product.id,
                  quantity: product.quantity,
                  properties: properties
                };
              }); // Turn the array upside down
              productData.reverse();

              // Now from the first item remove the properties.sub
              if (productData.length > 0 && productData[productData.length - 1].properties) {
                productData[productData.length - 1].properties._sub = "false";
              }

              // Voeg eigenschappen toe als er meer dan 1 item is
              if (this.addToCartObject.length === 1) {
                productData[0].properties = Object.keys(deliveryMatchProperties).length ? deliveryMatchProperties : null;
              }

              // Setup the request body
              requestBody = {
                items: productData
              };
              _context.prev = 6;
              _context.next = 9;
              return $.ajax({
                url: "/cart/add.js",
                type: "POST",
                contentType: "application/json",
                // Shopify serves /cart/add.js as text/javascript; without an explicit
                // dataType jQuery evaluates the JSON as a script (SyntaxError).
                dataType: "json",
                data: JSON.stringify(requestBody)
              }).then(function () {
                mutationSucceeded = true;
                preorderSyncPending = true;
                return window.syncPreorderCart().then(function () { preorderSyncPending = false; });
              });
            case 9:
              _context.next = 11;
              return fetch(window.Shopify.routes.root + 'cart.js');
            case 11:
              res = _context.sent;
              if (!res.ok) throw new Error('Could not refresh cart after add');
              _context.next = 14;
              return res.json();
            case 14:
              cart = _context.sent;
              // Update cart count badges immediately
              document.querySelector('.js-cart-count').classList.add('header-main__cart--hasitems');
              document.querySelectorAll('.js-cart-count').forEach(function (el) {
                el.textContent = cart.item_count;
              });
              _context.next = 18;
              return (0,_custom_add_to_cart__WEBPACK_IMPORTED_MODULE_0__.updateCart)(cart);
            case 18:
              (0,_functions__WEBPACK_IMPORTED_MODULE_1__.openMiniCart)();
              _context.next = 25;
              break;
            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](6);
              if (mutationSucceeded) {
                // The add is committed; report a failed attribute write separately from presentation.
                console.warn(preorderSyncPending ? 'PotFinder: added, but pre-order cart attribute sync failed' : 'PotFinder: added, but cart refresh failed', _context.t0);
                return _context.abrupt("return", { preorderSyncFailed: preorderSyncPending, cartRefreshFailed: !preorderSyncPending });
              }
              throw _context.t0;
            case 25:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[6, 21]]);
      }));
      function addToCart(event) {
        if (event) event.preventDefault();
        var button = event && event.currentTarget || document.querySelector(this.addToCartButton);
        if (button && button.disabled) return Promise.resolve();
        if (window.GreetingCard && !window.GreetingCard.validate()) return Promise.resolve();
        var section = document.querySelector('.product-section--action');
        clearPotFinderError(section);
        if (!window.FlorafyUI.setButtonPending(button, true)) return Promise.resolve();
        button.classList.remove('is-error', 'is-success');
        var label = button.querySelector('.ui-button__label');
        var originalLabelNodes = label && Array.from(label.childNodes);
        return _addToCart.apply(this, arguments).then(function (result) {
          if (result && (result.preorderSyncFailed || result.cartRefreshFailed)) showPotFinderCartLink(section, button, result.preorderSyncFailed);
          button.classList.remove('is-loading');
          button.classList.add('is-success');
          button.setAttribute('aria-busy', 'false');
          if (label) label.textContent = window.translations?.button?.added || 'Toegevoegd!';
          setTimeout(function () {
            window.FlorafyUI.setButtonPending(button, false);
            button.classList.remove('is-success');
            if (label) label.replaceChildren(...originalLabelNodes);
          }, 2000);
        }).catch(function (error) {
          window.FlorafyUI.setButtonPending(button, false);
          button.classList.add('is-error');
          showPotFinderError(section, button, error);
        });
      }
      return addToCart;
    }()
    /**
     * Update quantity
     *
     * @param {Number} increment
     */
    )
  }, {
    key: "updateQuantity",
    value: function updateQuantity(increment) {
      // Get the current quantity
      var currentQuantity = parseInt($(this.quantityInputSelector).val(), 10);

      // If it's not a number, set it to 0
      if (isNaN(currentQuantity)) currentQuantity = 0;

      // Get the new quantity
      var newQuantity = currentQuantity + increment;

      // Overwrite the value
      if (newQuantity >= 1) $(this.quantityInputSelector).val(newQuantity);

      // Update the total configuration price
      this.updateTotalConfigurationPrice();
    }
  }]);
}();
/**
 * Show the find-my-pot product quickview
 */
var showQuickView = function showQuickView(event) {
  // Get the product and fill the quickview
  var product = $(event.currentTarget);
  $(".js-quickview__title").html(product.data("title"));
  $(".js-quickview__description").html(product.data("description"));
  $(".js-quickview__image").attr("src", product.data("image"));
  $(".js-quickview__link").attr("href", product.data("url"));
  var price = product.data("price");
  var priceString = price.toString();
  var modifiedPrice = priceString.slice(0, -2) + ",<span>" + priceString.slice(-2) + "</span>";
  $(".js-quickview__price").html(modifiedPrice);
};


/***/ }),

/***/ "./src/js/functions.js":
/*!*****************************!*\
  !*** ./src/js/functions.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   closeAccountPanel: () => (/* binding */ closeAccountPanel),
/* harmony export */   closeFilterPanel: () => (/* binding */ closeFilterPanel),
/* harmony export */   closeLangPanel: () => (/* binding */ closeLangPanel),
/* harmony export */   closeMiniCart: () => (/* binding */ closeMiniCart),
/* harmony export */   filterToggle: () => (/* binding */ filterToggle),
/* harmony export */   lockHTML: () => (/* binding */ lockHTML),
/* harmony export */   openAccountPanel: () => (/* binding */ openAccountPanel),
/* harmony export */   openFilterPanel: () => (/* binding */ openFilterPanel),
/* harmony export */   openLangPanel: () => (/* binding */ openLangPanel),
/* harmony export */   openMiniCart: () => (/* binding */ openMiniCart),
/* harmony export */   toggleMiniCart: () => (/* binding */ toggleMiniCart),
/* harmony export */   unlockHTML: () => (/* binding */ unlockHTML)
/* harmony export */ });
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");
var openMiniCart = function openMiniCart() {
  $(".drawer-cart").addClass("is-open");
};
var toggleMiniCart = function toggleMiniCart() {
  $(".drawer-cart").toggleClass("is-open");
};
var closeMiniCart = function closeMiniCart() {
  $(".drawer-cart").removeClass("is-open");
};
var openLangPanel = function openLangPanel() {
  $(".drawer-lang").each(function () {
    if (!this.open) { this.classList.add("is-open"); this.showModal(); }
  });
};
var closeLangPanel = function closeLangPanel() {
  $(".drawer-lang").each(function () {
    if (this.open) this.close();
    this.classList.remove("is-open");
  });
};
var openAccountPanel = function openAccountPanel() {
  $(".drawer-account").each(function () {
    if (!this.open) { this.classList.add("is-open"); this.showModal(); }
  });
};
var closeAccountPanel = function closeAccountPanel() {
  $(".drawer-account").each(function () {
    if (this.open) this.close();
    this.classList.remove("is-open");
  });
};
var filterToggle = function filterToggle(element) {
  if (element.parent().hasClass('is-hidden')) {
    element.parent().removeClass('is-hidden').find('.collection-filter-content').stop().slideToggle();
  } else {
    element.parent().addClass('is-hidden').find('.collection-filter-content').stop().slideToggle();
  }
};
var openFilterPanel = function openFilterPanel() {
  $(".drawer-filter").toggleClass("is-open");
};
var closeFilterPanel = function closeFilterPanel() {
  $(".drawer-filter").removeClass("is-open");
};
var lockHTML = function lockHTML() {
  if (!$("html").hasClass("is-locked")) {
    $("html").addClass("is-locked");
  }
};
var unlockHTML = function unlockHTML() {
  $("html").removeClass("is-locked");
};


/***/ }),

/***/ "./src/js/sliders.js":
/*!***************************!*\
  !*** ./src/js/sliders.js ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   debounceReInitSliders: () => (/* binding */ debounceReInitSliders),
/* harmony export */   destroyHomeHeroAsideMobileSlider: () => (/* binding */ destroyHomeHeroAsideMobileSlider),
/* harmony export */   initHomeHeroAsideMobileSlider: () => (/* binding */ initHomeHeroAsideMobileSlider)
/* harmony export */ });
/* harmony import */ var slick_slider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! slick-slider */ "./node_modules/slick-slider/slick/slick.js");
/* harmony import */ var slick_slider__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slick_slider__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _find_my_pot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./find-my-pot */ "./src/js/find-my-pot.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");


var mq = {
  xs: 425,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
  xxxl: 1600
};

/***********************
 ***********************
 *** Oppot Slider ***
 ***********************
 ***********************/
var OppotSliderSelector = ".js-oppot-slider";
var OppotSliderAttributes = {
  slidesToShow: 4,
  slidesToScroll: 1,
  grabCursor: true,
  dots: false,
  arrows: false,
  rows: 0,
  speed: 150,
  swipeToSlide: true,
  infinite: true,
  responsive: [{
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 3
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 2.5
    }
  }, {
    breakpoint: mq.xs,
    settings: {
      slidesToShow: 2.5
    }
  }]
};

// Init the slider
function initOppotSlider() {
  window.florafySliderControls.initSlick(OppotSliderSelector, OppotSliderAttributes, $);
}

/***************************
 ***************************
 ***  Drawer Crosssells  ***
 ***************************
 ***************************/
var DrawerCrosssellsSelector = ".js-drawer-crosssells";
var DrawerCrosssellsAttributes = {
  slidesToShow: 1.5,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  rows: 0,
  infinite: false,
  responsive: [{
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 1.5
    }
  }, {
    breakpoint: mq.md,
    settings: {
      slidesToShow: 1.25
    }
  }]
};
// Init the slider
function initDrawerCrosssels() {
  window.florafySliderControls.initSlick(DrawerCrosssellsSelector, DrawerCrosssellsAttributes, $);
}

/***********************
 ***********************
 ***  Home Hero USP  ***
 ***********************
 ***********************/
var HomeHeroUspSelector = ".js-home-hero-usp-slider";
var HomeHeroUspAttributes = {
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  rows: 1,
  responsive: [{
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 1,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 800,
      cssEase: 'ease-in-out',
      vericalCenter: true
    }
  }]
};
// Init the slider
function initHomeHeroUsp() {
  window.florafySliderControls.initSlick(HomeHeroUspSelector, HomeHeroUspAttributes, $);
}

/****************************
 ****************************
 *** Home Products Slider ***
 ****************************
 ****************************/
var HomeProductsSliderSelector = ".js-home-products-slider";
var HomeProductsSliderAttributes = {
  slidesToShow: 4.5,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  rows: 0,
  infinite: false,
  swipe: false,
  touchMove: false,
  draggable: false,
  responsive: [{
    breakpoint: mq.xl,
    settings: {
      slidesToShow: 3.5
    }
  }, {
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2.2
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 1.5
    }
  }]
};

// Init the slider
function initHomeProductsSlider() {
  window.florafySliderControls.initSlick(HomeProductsSliderSelector, HomeProductsSliderAttributes, $);
}

/************************
 ************************
 *** Home Sale Slider ***
 ************************
 ************************/
var HomeSaleSliderSelector = ".js-home-sale-slider";
var HomeSaleSliderAttributes = {
  slidesToShow: 4.5,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  rows: 0,
  infinite: false,
  swipe: false,
  touchMove: false,
  draggable: false,
  responsive: [{
    breakpoint: mq.xl,
    settings: {
      slidesToShow: 3.5
    }
  }, {
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2.2
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 1.5
    }
  }]
};

// Init the slider
function initHomeSaleSlider() {
  window.florafySliderControls.initSlick(HomeSaleSliderSelector, HomeSaleSliderAttributes, $);
}

/****************************
 ****************************
 *** Home Category Slider ***
 ****************************
 ****************************/
var HomeCategorySliderSelector = ".js-home-category-slider";
var HomeCategorySliderAttributes = {
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  arrows: false,
  rows: 0,
  infinite: false,
  swipe: false,
  touchMove: false,
  draggable: false,
  responsive: [{
    breakpoint: mq.xxl,
    settings: {
      slidesToShow: 4
    }
  }, {
    breakpoint: mq.xl,
    settings: {
      slidesToShow: 3
    }
  }, {
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2.25
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 1.35,
      arrows: false
    }
  }]
};

// Init the slider
function initHomeCategorySlider() {
  window.florafySliderControls.initSlick(HomeCategorySliderSelector, HomeCategorySliderAttributes, $);
}

/************************
 ************************
 *** Home News Slider ***
 ************************
 ************************/
var HomeNewsSliderSelector = ".js-home-news-slider";
var HomeNewsSliderAttributes = {
  slidesToShow: 2,
  slidesToScroll: 1,
  infinite: false,
  swipe: false,
  touchMove: false,
  draggable: false,
  responsive: [{
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 1.5,
      arrows: false
    }
  }, {
    breakpoint: mq.sm,
    settings: {
      slidesToShow: 1.2,
      arrows: false
    }
  }]
};

// Init the slider
function initHomeNewsSlider() {
  window.florafySliderControls.initSlick(HomeNewsSliderSelector, HomeNewsSliderAttributes, $);
}


/*********************
 *********************
 *** Upsell Slider ***
 *********************
 *********************/
var UpsellSliderSelector = ".js-upsell-slider";
var UpsellSliderAttributes = {
  slidesToShow: 4.3,
  slidesToScroll: 1,
  dots: false,
  focusOnSelect: false,
  arrows: false,
  infinite: false,
  rows: 0,
  swipe: false,
  touchMove: false,
  draggable: false,
  responsive: [{
    breakpoint: mq.xxxl,
    settings: {
      slidesToShow: 3.3
    }
  }, {
    breakpoint: mq.xl,
    settings: {
      slidesToShow: 2.3
    }
  }, {
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2.3
    }
  }, {
    breakpoint: mq.md,
    settings: {
      slidesToShow: 1.3
    }
  }]
};

// Init the slider
function initUpsellSlider() {
  window.florafySliderControls.initSlick(UpsellSliderSelector, UpsellSliderAttributes, $);
}

/******************************
 ******************************
 *** Layout Products Slider ***
 ******************************
 ******************************/
var LayoutProductsSliderSelector = ".js-layout-products";
var LayoutProductsSliderAttributes = {
  slidesToShow: 5,
  slidesToScroll: 1,
  dots: false,
  focusOnSelect: false,
  arrows: false,
  rows: 0,
  infinite: false,
  swipe: false,
  touchMove: false,
  draggable: false,
  responsive: [{
    breakpoint: mq.xxxl,
    settings: {
      slidesToShow: 4
    }
  }, {
    breakpoint: mq.xl,
    settings: {
      slidesToShow: 3
    }
  }, {
    breakpoint: mq.lg,
    settings: {
      slidesToShow: 2.5
    }
  }, {
    breakpoint: mq.md,
    settings: {
      slidesToShow: 2
    }
  }]
};

// Init the slider
function initLayoutProductsSlider() {
  window.florafySliderControls.initSlick(LayoutProductsSliderSelector, LayoutProductsSliderAttributes, $);
}

/********************************
 ********************************
 *** Product Hero Main Slider ***
 ********************************
 ********************************/
var ProductHeroMainSliderSelector = ".js-product-hero-main-slider";
var ProductHeroMainSliderAttributes = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  // asNavFor removed - using native scroll thumbnails with custom JS sync
  rows: 0,
  infinite: false
};
function initProductHeroMainSlider() {
  window.florafySliderControls.initSlick(ProductHeroMainSliderSelector, ProductHeroMainSliderAttributes, $);
}
function goToSlide(index) {
  $(ProductHeroMainSliderSelector).slick('slickGoTo', index);
}

/****************************
 ****************************
 *** Product Hero Main Nav ***
 ****************************
 ****************************/
var ProductHeroMainNavSelector = ".js-product-hero-main-nav";
var ProductHeroMainNavAttributes = {
  slidesToShow: 3.3,
  slidesToScroll: 1,
  asNavFor: ".js-product-hero-main-slider",
  dots: false,
  focusOnSelect: true,
  arrows: false,
  rows: 0,
  infinite: false,
  responsive: [{
    breakpoint: 992,
    settings: {
      slidesToShow: 2.3,
      vertical: true,
      verticalSwiping: true,
      swipe: true,
      touchMove: true,
      draggable: true
    }
  }]
};
function initProductHeroMainNav() {
  // Disabled - using native scroll instead of Slick for thumbnails
  // $(ProductHeroMainNavSelector).slick(ProductHeroMainNavAttributes);
}

/********************************
 ********************************
 *** Product Hero Main Slider ***
 ********************************
 ********************************/
var HomeHeroAsideMobileSelector = ".js-home-hero-aside-mobile";
var HomeHeroAsideMobileAttributes = {
  slidesToShow: 1.5,
  slidesToScroll: 1,
  mobileFirst: true,
  arrows: false,
  dots: false,
  infinite: false,
  swipe: false,
  touchMove: false,
  draggable: false
};
function initHomeHeroAsideMobileSlider() {
  window.florafySliderControls.initSlick(HomeHeroAsideMobileSelector, HomeHeroAsideMobileAttributes, $);
}
function destroyHomeHeroAsideMobileSlider() {
  if ($(HomeHeroAsideMobileSelector).hasClass("slick-initialized")) {
    $(HomeHeroAsideMobileSelector).slick("unslick");
  }
}

// Init all sliders
initHomeHeroUsp();
initDrawerCrosssels();
initHomeProductsSlider();
initHomeSaleSlider();
initHomeCategorySlider();
initHomeNewsSlider();
initUpsellSlider();
initLayoutProductsSlider();
initProductHeroMainSlider();
initProductHeroMainNav();

// Progress bar, previous/next buttons and drag-to-scroll for every
// native-scroll slider. The work lives in slider-controls.js; this only lists
// the sliders. Binding is idempotent per .slick-list, so calling it again after
// theme code inserts a new slider creates controls only for the new list.
function initSliderProgressBars() {
  if (!window.florafySliderControls) return;
  var sliderSelectors = [
    '.js-home-products-slider',
    '.js-home-sale-slider',
    '.js-home-category-slider',
    '.js-home-news-slider',
    '.js-upsell-slider',
    '.js-layout-products',
    '.js-home-hero-aside-mobile'
  ];

  sliderSelectors.forEach(function(selector) {
    document.querySelectorAll(selector).forEach(function(slider) {
      window.florafySliderControls.bind(slider);
    });
  });
}

var sliderProgressFrame = null;
function scheduleSliderProgressBars() {
  if (sliderProgressFrame !== null) return;
  sliderProgressFrame = window.requestAnimationFrame(function () {
    sliderProgressFrame = null;
    initSliderProgressBars();
  });
}

// Slick builds its list synchronously. Wait for the browser's next layout
// frame before measuring it, without holding every slider for a fixed delay.
scheduleSliderProgressBars();

// Re init function
function reInitSliders() {
  // Each initializer skips existing roots and only handles new content.
  initHomeHeroUsp();
  initDrawerCrosssels();
  initHomeProductsSlider();
  initHomeSaleSlider();
  initHomeCategorySlider();
  initHomeNewsSlider();
  initUpsellSlider();
  initLayoutProductsSlider();
  initProductHeroMainSlider();
  initProductHeroMainNav();

  scheduleSliderProgressBars();

  // This is the exceptional version:
  // initOppotSlider(); // Disabled - using native scroll instead
}
var sliderRefreshFrame = null;
function debounceReInitSliders() {
  if (sliderRefreshFrame !== null) return;
  sliderRefreshFrame = window.requestAnimationFrame(function () {
    sliderRefreshFrame = null;
    reInitSliders();
  });
}

// Slick's own responsive listener and each control's ResizeObserver handle
// viewport changes. Refreshes are only needed when theme code inserts content.
window.addEventListener("variationchange", function (e) {
  return goToSlide(e.detail.index);
});

// Re-init product hero slider after combined-listing section swap
window.addEventListener("combined-listing:swapped", function () {
  initProductHeroMainSlider();
  initProductHeroMainNav();
  scheduleSliderProgressBars();
});

// Fix the slider with the oppot values
function initOppotConfigurator() {
  // Order divs first
  var $slider = $(".js-oppot-slider");
  var $slides = $(".js-oppot-slider>div");
  var uniqueVariations = [];
  $slides.sort(function (a, b) {
    var orderA = $(a).data("order");
    var orderB = $(b).data("order");

    // First sort by data-order
    if (orderA !== orderB) {
      return orderA - orderB;
    }

    // If data-order is the same, sort by data-suborder
    var subOrderA = $(a).data("suborder");
    var subOrderB = $(b).data("suborder");
    return subOrderA - subOrderB;
  }).each(function (index, slide) {
    var variation = $(slide).find("input").val();
    if (!uniqueVariations.includes(variation)) {
      uniqueVariations.push(variation);
    } else {
      $slides.splice(index, 1);
    }
  });
  // Empty the slider
  $slider.empty();

  // Add the slides back in
  $slides.each(function (index, slide) {
    $slider.append(slide);
  });

  // Now init the configurator
  if (document.getElementById("find_my_pot_configurator")) {
    // initOppotSlider(); // Disabled - using native scroll instead
    new _find_my_pot__WEBPACK_IMPORTED_MODULE_1__.PotFinder();
  }
}
initOppotConfigurator();

// Export the reInitSliders function


/***/ }),

/***/ "./src/js/toggles.js":
/*!***************************!*\
  !*** ./src/js/toggles.js ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _functions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./functions */ "./src/js/functions.js");
/* provided dependency */ var $ = __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js");

$(document).on("click", ".js-footer-toggle ", function (e) {
  e.preventDefault();
  $(this).parent().toggleClass("is-active");
  $(this).parent().next("nav").children("ul").stop().slideToggle();
});

// Sluit alle panels
function closeAllPanels() {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeMiniCart)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeLangPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeAccountPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeFilterPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.unlockHTML)();
  // The mobile menu lives in site-header.js and closes on this event.
  document.dispatchEvent(new CustomEvent("site-header:close-menu"));
}
$(".js-header-search input").on("input", function () {
  if ($(this).val().length > 0) {
    closeAllPanels();
  }
});
// Compact mobile header (frame E4). Below 1200px the 58px row stays fixed at the
// top once the utility strip has scrolled away; the search row and trust strip
// scroll on underneath. site-header.js owns the desktop compact state.
(function initStickyHeader() {
  var header = document.querySelector(".site-header .header");
  var headerMain = header && header.querySelector(".header-main");
  if (!header || !headerMain) return;

  var mobile = window.matchMedia("(max-width: 1199.98px)");
  var threshold = 0;
  var isSticky = false;
  var frame = 0;

  function setSticky(nextSticky) {
    if (isSticky === nextSticky) return;
    isSticky = nextSticky;
    header.classList.toggle("is-sticky", nextSticky);
    if (nextSticky) {
      document.documentElement.style.setProperty("--panel-top", headerMain.offsetHeight + "px");
    } else {
      document.documentElement.style.removeProperty("--panel-top");
    }
  }

  function update() {
    frame = 0;
    setSticky(mobile.matches && window.scrollY > threshold);
  }

  function measure() {
    // Measure the row in the expanded layout, then restore the state for this scroll position.
    setSticky(false);
    if (mobile.matches) threshold = headerMain.getBoundingClientRect().top + window.scrollY;
    update();
  }

  window.addEventListener("scroll", function () {
    if (!frame) frame = window.requestAnimationFrame(update);
  }, { passive: true });
  window.addEventListener("resize", measure);
  window.addEventListener("pageshow", measure);
  window.addEventListener("load", measure);
  measure();
})();

// Minicart openen/sluiten
$(document).on("click", ".js-cart-toggle", function (e) {
  closeAllPanels(); // Sluit andere panels
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.toggleMiniCart)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();
});
$(document).on("click", ".js-minicart-close", function (e) {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeMiniCart)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.unlockHTML)();
});

// Shopify recovery errors belong to the shared recovery dialog.
if (document.querySelector("[data-account-recovery-error]")) {
  const dialog = document.getElementById("forgotPassword");
  if (dialog && !dialog.open) {
    dialog.showModal();
    (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();
    const invalidField = dialog.querySelector('[aria-invalid="true"]');
    if (invalidField) invalidField.focus();
  }
}

// Native Escape and the close buttons share the existing scroll-lock owner.
document.querySelectorAll("#forgotPassword, #AccountDrawer, #LanguageDrawer").forEach(function (dialog) {
  dialog.addEventListener("close", function () {
    dialog.classList.remove("is-open");
    if (!document.querySelector("#forgotPassword[open], #AccountDrawer[open], #LanguageDrawer[open], .drawer.is-open")) {
      (0,_functions__WEBPACK_IMPORTED_MODULE_0__.unlockHTML)();
    }
  });
});

// Native dialogs remember focus before showModal; mobile menu actions are hidden after closeAllPanels.
function focusAccountOrLanguageOpener(opener) {
  const trigger = opener.matches("button, a") ? opener : opener.querySelector("button, a");
  const focusReturn = trigger && trigger.getClientRects().length > 0
    ? trigger
    : document.querySelector(".site-header .js-header-toggle");
  if (focusReturn && focusReturn.getClientRects().length > 0) {
    focusReturn.focus({ preventScroll: true });
  }
}

// Taalpanel openen/sluiten
$(document).on("click", ".js-lang-switch", function (e) {
  e.preventDefault();
  closeAllPanels(); // Sluit andere panels
  focusAccountOrLanguageOpener(this);
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openLangPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();
});
$(document).on("click", ".js-drawer-lang-close", function (e) {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeLangPanel)();
});

// Accountpanel openen/sluiten
$(document).on("click", ".js-account-toggle", function (e) {
  e.preventDefault();
  closeAllPanels(); // Sluit andere panels
  focusAccountOrLanguageOpener(this);
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openAccountPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();
});
$(document).on("click", ".js-drawer-account-close", function (e) {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeAccountPanel)();
});

// Filterpanel openen/sluiten
$(document).on("click", ".js-header-collection-mobile-filter", function (e) {
  closeAllPanels(); // Sluit andere panels
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.openFilterPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.lockHTML)();
});
$(document).on("click", ".js-drawer-filter-close", function (e) {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.closeFilterPanel)();
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.unlockHTML)();
});
$(document).on("click", ".js-collection-filter-toggle", function (e) {
  (0,_functions__WEBPACK_IMPORTED_MODULE_0__.filterToggle)($(this));
});
$(document).on("click", ".js-show-more", function (e) {
  var readMore = $(this);
  var container = readMore.parent().find(".js-content-container");
  var newHeight = container.find(".colums-2").height();
  if (container.hasClass("is-show")) {
    $(".js-content-container").animate({
      height: 100
    }, 500);
    container.removeClass("is-show");
    $(this).next(span).html("Toon minder");
  } else {
    $(".js-content-container").animate({
      height: newHeight
    }, 500);
    container.addClass("is-show");
    $(this).next(span).html("Toon minder");
  }
});
$(document).on("click", ".js-faq-toggle", function (e) {
  e.preventDefault();
  $(this).toggleClass("is-active");
  $(this).next().stop().slideToggle(300);
});

/***/ }),

/***/ "./src/scss/app.scss":
/*!***************************!*\
  !*** ./src/scss/app.scss ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, ["app","/vendor"], () => (__webpack_exec__("./src/js/app.js"), __webpack_exec__("./src/scss/app.scss")));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);
